import React from "react"

import { Drawer } from "antd"

import { useIsMobile } from "../hooks/isMobile.hook"

export const DrawerElement: React.FunctionComponent<
    IDrawerElementProps
> = props => {
    const isMobile = useIsMobile()

    return (
        <Drawer
            className={props.className}
            open={props.isOpen}
            onClose={props.onClose}
            // Bottom sheet on mobile
            placement={isMobile ? "bottom" : "right"}
            width={props.width}
            height="85vh"
            title={props.title}
            footer={props.footer}
        >
            {props.children}
        </Drawer>
    )
}

interface IDrawerElementProps {
    className?: string
    isOpen: boolean
    onClose: () => void
    width?: number
    title?: React.ReactNode
    footer?: React.ReactNode
    children?: React.ReactNode
}
